import selector from "../functions/selector";
import { clearResult, showError } from "./getPrice";
import { log } from "./logger";
//import { clearResult } from "./getPrice";
export function validateTariffcalculator() {
    log("triggered validate tariffcalculator");
    var plzCity;
    var usage;
    var street = jQuery(selector.STREET);
    var housenumber = jQuery(selector.NUMBER);
    var tariffcalculatorButton = jQuery(selector.TARIFFCALCULATORBUTTON);
    if (window.business) {
        plzCity = jQuery("input[id='gewerbe_tarif_plz']");
        usage = jQuery("input[id='gewerbe_tarif_kwh']");
    }
    else if (window.waermepumpe) {
        plzCity = jQuery("input[id='waermepumpe_tarif_plz']");
        usage = jQuery("input[id='waermepumpe_tarif_kwh']");
    }
    else if (window.mieterstrom) {
        plzCity = jQuery("input[id='mieterstrom_tarif_plz']");
        usage = jQuery("input[id='mieterstrom_tarif_kwh']");
    }
    else {
        plzCity = jQuery("input[id='privat_tarif_plz']");
        usage = jQuery("input[id='privat_tarif_kwh']");
    }
    if (plzCity == null || usage == null) {
        return;
    }
    if (window.mieterstrom) {
        if (plzCity.parent().attr("data-status") != "success" ||
            usage.parent().attr("data-status") != "success" ||
            street.parent().attr("data-status") != "success" ||
            housenumber.parent().attr("data-status") != "success") {
            // GERADE DABEI HIER VALIDIERUNG ZU MACHEN
            log("Is mieterstrom?");
            log(window.mieterstrom);
            tariffcalculatorButton.prop("disabled", true);
            return false;
        }
    }
    else {
        if (plzCity.parent().attr("data-status") != "success" ||
            usage.parent().attr("data-status") != "success") {
            log("Is non mieterstrom?");
            log(window.mieterstrom);
            tariffcalculatorButton.prop("disabled", true);
            return false;
        }
    }
    log("Valid tariffcalculator");
    tariffcalculatorButton.prop("disabled", false);
    return true;
}
export function validatePlzCity() {
    var plzCity;
    var success = false;
    if (window.business) {
        plzCity = jQuery("input[id='gewerbe_tarif_plz']");
    }
    else if (window.waermepumpe) {
        plzCity = jQuery("input[id='waermepumpe_tarif_plz']");
    }
    else if (window.mieterstrom) {
        plzCity = jQuery("input[id='mieterstrom_tarif_plz']");
    }
    else {
        plzCity = jQuery("input[id='privat_tarif_plz']");
    }
    if (plzCity.val()?.toString().length == 0) {
        plzCity.parent().attr("data-status", "error");
        plzCity.siblings(".input-error-message").children()[0].innerText = "Bitte Postleitzahl angeben";
        return false;
    }
    if (window.ccitycode !== 0 && !Number.isNaN(window.ccitycode)) {
        log(window.ccitycode);
        success = true;
    }
    if (success) {
        plzCity.parent().attr("data-status", "success");
    }
    else {
        plzCity.parent().attr("data-status", "error");
        plzCity.siblings(".input-error-message").children()[0].innerText = "Postleitzahl nicht im Liefergebiet";
    }
    validateTariffcalculator();
    return success;
}
export function validateUsage() {
    var usage;
    if (window.business) {
        usage = jQuery("input[id='gewerbe_tarif_kwh']");
    }
    else if (window.waermepumpe) {
        usage = jQuery("input[id='waermepumpe_tarif_kwh']");
    }
    else if (window.mieterstrom) {
        usage = jQuery("input[id='mieterstrom_tarif_kwh']");
    }
    else {
        usage = jQuery("input[id='privat_tarif_kwh']");
    }
    var success = false;
    var parsed = Number.parseInt(usage.val());
    log(parsed);
    if (!isNaN(parsed)) {
        if (window.business || window.waermepumpe) {
            if (parsed > 80000) {
                showError(selector.ERRORS.TOLARGEKWH80);
                success = false;
            }
            else {
                success = true;
                clearResult();
            }
        }
        else if (!window.waermepumpe && !window.business && !window.mieterstrom) {
            if (parsed > 10000) {
                showError(selector.ERRORS.TOLARGEKWH10);
                success = false;
            }
            else {
                success = true;
                clearResult();
            }
        }
        else if (parsed > 10000) {
            showError(selector.ERRORS.TOLARGEKWH10);
            success = false;
        }
        else {
            success = true;
            clearResult();
        }
    }
    else {
        success = false;
        clearResult();
    }
    if (success) {
        usage.parent().attr("data-status", "success");
    }
    else {
        usage.parent().attr("data-status", "error");
        usage.siblings(".input-error-message").children()[0].innerText = "Ungültiger Jahresverbrauch";
    }
    validateTariffcalculator();
    return success;
}
export function validateStreet() {
    log("triggered validate street");
    var street = jQuery(selector.STREET);
    var success = false;
    if (String(jQuery(street).val()).length >= 4) {
        var autocomplete = jQuery("div[autocomplete-for=" + street.attr("id") + "]");
        //@ts-ignore
        var entries = autocomplete.children("div:not(.default)");
        for (let index = 0; index < entries.length; index++) {
            const element = entries[index];
            if (jQuery(element).attr("value")?.trim()?.toLowerCase() == String(street.val()?.toString().trim().toLowerCase())) {
                success = true;
                break;
            }
        }
    }
    if (success) {
        street.parent().attr("data-status", "success");
    }
    else {
        street.parent().attr("data-status", "error");
        street.siblings(".input-error-message").children()[0].innerText = "Ungültige Straße";
    }
    validateTariffcalculator();
    return success;
}
export function validateHousenumber() {
    var housenumber = jQuery(selector.NUMBER);
    var value = housenumber.val()?.toString();
    var success = false;
    if (value?.trim() != "" && value?.trim() != null && value?.trim() != undefined) {
        success = true;
    }
    if (success) {
        housenumber.parent().attr("data-status", "success");
    }
    else {
        housenumber.parent().attr("data-status", "error");
    }
    validateTariffcalculator();
    return success;
}
export function validPrice() {
    //prüft die benötigen Felder zur preisberechnung
    //postleitzahl
    var plz = checkPLZ(String(jQuery(selector.PLZ).val()).trim());
    //stadt
    var city = checkCity(String(jQuery(selector.CITY).val()).trim());
    //straße
    var street = checkStreet(String(jQuery(selector.STREET).val()).trim());
    //hausnummer
    var nummer = checkHouseNumber(String(jQuery(selector.NUMBER).val()).trim());
    log(`Validation:\nPLZ: ${plz}\nCITY: ${city}\nSTREET: ${street}\nNUMBER: ${nummer}`);
    return plz && city && street && nummer;
}
export function empty() {
    return (String(jQuery(selector.PLZ).val()).trim() != "" &&
        String(jQuery(selector.CITY).val()).trim() != "" &&
        String(jQuery(selector.STREET).val()).trim() != "" &&
        String(jQuery(selector.NUMBER).val()).trim() != "");
}
export function checkPLZ(plz) {
    if (jQuery(selector.PLZ).hasClass("too_short")) {
        return false;
    }
    //length
    if (plz.length == 0) {
        jQuery(selector.PLZ).val("");
    }
    if (plz.length != 5) {
        //showerror("tarif_plz", "Ihre Postleitzahl muss fünfstellig sein!");
        return false;
    }
    let regex = /^[0-9]+$/;
    if (!regex.test(plz) && String(jQuery(selector.PLZ).val()).trim() != "") {
        //showerror("tarif_plz", "Ihre Postleitzahl darf nur Zahlen enthalten!");
        return false;
    }
    //lifterror("tarif_plz");
    return true;
}
export function checkHouseNumber(number) {
    let regex = /^[0-9a-zA-Z]+$/;
    if (!regex.test(number) && String(jQuery(selector.NUMBER).val()).trim() != "") {
        //showerror("tarif_nummer", "Ihre Hausnummer darf nur Zahlen enthalten!");
        return false;
    }
    //lifterror("tarif_nummer");
    return true;
}
export function checkStreet(street) {
    if (jQuery(selector.STREET).hasClass("too_short")) {
        return false;
    }
    let regex = /^[a-zA-Zöäüß\- \s\.]+$/gi;
    if (!regex.test(street) && String(jQuery(selector.STREET).val()).trim() != "") {
        //showerror("tarif_strasse", "Ihre Straße darf nur Buchstaben enthalten!");
        jQuery(".error-dropper").slideDown();
        return false;
    }
    /*
              if (!autocompletestreet(ccitycode)) {
                  return false;
              }*/
    //lifterror("tarif_strasse");
    jQuery(".error-dropper").slideUp();
    return true;
}
export function checkCity(city) {
    if (jQuery(selector.CITY).hasClass("too_short")) {
        return false;
    }
    let regex = /^[a-zA-ZöäüßÖÄÜ\-\s]+$/gi;
    if (!regex.test(city) && String(jQuery(selector.CITY).val()).trim() != "") {
        let whitespaceBetweenWordsRegex = /[\b\s\b]/gi;
        if (!whitespaceBetweenWordsRegex.test(city) && !regex.test(city.replace(/ /g, ''))) {
            //showerror("tarif_ort", "Ihr Ort darf nur Buchstaben enthalten!");
            return false;
        }
    }
    //lifterror("tarif_ort");
    return true;
}
